<template>
  <div>
    <div class="flex items-center pb-2">
      <!-- Back Button (left) -->
      <div class="w-1/12 flex justify-start">
        <BackButton v-if="withBackBtn" text="Back" @click="$router.go(-1)" />
      </div>

      <div class="w-10/12 flex justify-center">
        <div
          class="text-base sm:text-title text-primary font-semibold text-center font-inter text-[28px] leading-none tracking-normal"
        >
          {{ title }}
        </div>
      </div>

      <div class="w-1/12 flex justify-end">
        <SwdInfoBtn v-if="witchInfoBtn" />
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'SwdLeadSubHeader',
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
    info: {
      type: String,
      required: false,
      default: '',
    },
    breadCrumbsData: {
      type: Array,
      required: false,
      default: () => [],
    },
    withBackBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    witchInfoBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const router = useRouter()

    const back = () => {
      router.push({ name: props.backPage })
    }

    return {
      back,
    }
  },
}
</script>
